module.exports = __webpack_public_path__ + "img/5-3.df29dd3e.svg";